/* codex-ravis90-auto-apply:start */
(function () {
  'use strict';

  var code = 'RAVIS90';
  var discountParamPattern = /([?&])discount=/i;

  function withDiscount(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin && !/myshopify\.com$/i.test(parsed.hostname)) return url;
      parsed.searchParams.set('discount', code);
      return parsed.href;
    } catch (error) {
      if (discountParamPattern.test(url)) return url.replace(/([?&])discount=[^&#]*/i, '$1discount=' + encodeURIComponent(code));
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'discount=' + encodeURIComponent(code);
    }
  }

  function isCheckoutUrl(value) {
    return typeof value === 'string' && /\/checkout(?:\?|$|\/)/i.test(value);
  }

  function isCartUrl(value) {
    return typeof value === 'string' && /\/cart(?:\?|$|\/)/i.test(value);
  }

  function patchLinks(root) {
    root = root || document;
    root.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (isCheckoutUrl(href) || isCartUrl(href)) {
        link.setAttribute('href', withDiscount(href));
        link.setAttribute('data-codex-ravis90-auto-apply', 'true');
      }
    });
    root.querySelectorAll('form[action]').forEach(function (form) {
      var action = form.getAttribute('action');
      if (isCheckoutUrl(action) || isCartUrl(action)) {
        form.setAttribute('action', withDiscount(action));
        form.setAttribute('data-codex-ravis90-auto-apply', 'true');
      }
    });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__codexRavis90AutoApply) return;
    var originalFetch = window.fetch;
    var wrappedFetch = function (input, init) {
      if (typeof input === 'string' && (isCheckoutUrl(input) || isCartUrl(input))) {
        input = withDiscount(input);
      } else if (input && input.url && (isCheckoutUrl(input.url) || isCartUrl(input.url))) {
        try { input = new Request(withDiscount(input.url), input); } catch (error) {}
      }
      return originalFetch.call(this, input, init);
    };
    wrappedFetch.__codexRavis90AutoApply = true;
    window.fetch = wrappedFetch;
  }

  function applyCheckoutRedirectIfNeeded(event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href], button, input[type="submit"]') : null;
    if (!target) return;
    var href = target.getAttribute && target.getAttribute('href');
    if (href && (isCheckoutUrl(href) || isCartUrl(href))) {
      target.setAttribute('href', withDiscount(href));
    }
  }

  function boot() {
    patchLinks(document);
    patchFetch();
    document.addEventListener('click', applyCheckoutRedirectIfNeeded, true);
    var observer = new MutationObserver(function () { patchLinks(document); });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
/* codex-ravis90-auto-apply:end */